module.exports = __webpack_public_path__ + "img/bttn-right.dc551fc3.svg";